<template>
  <div class="p10">
    <div class="bg p20 flex item-center flex-between">
     <div class="flex">
      <div class="operation">
      <el-button-group>
        <el-button type="primary" :plain="timeRange != 2" @click="setTime(2)">昨日</el-button>
        <el-button type="primary" :plain="timeRange != 3" @click="setTime(3)">前日</el-button>
        <el-button type="primary" :plain="timeRange != 7" @click="setTime(7)">近一周</el-button>
        <!-- <el-button type="primary" :plain="!!timeRange" @click="setTime()">自定义</el-button> -->
      </el-button-group>
     <el-date-picker
        v-if="!timeRange"
        v-model="dateRange"
        class="ml20"
        style="width: 260px;"
        value-format="yyyy-MM-dd"
        type="daterange"
        :clearable="false"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="getList(1)"
      ></el-date-picker>
    </div>
        <!-- <div class="flex item-center mr10"> 
            <div>时间范围：</div>
             <el-select
                size="small"
                clearable
                class="mr10"
                placeholder="选择时间"
                v-model="timeHorizon"
                style="width: 100px"
                filterable
           >
                <el-option label="昨天" value="yesterday"></el-option>
                <el-option label="前天" value="beforeYesterday"></el-option>
            </el-select>
        </div> -->
        
     </div>
     <div class="flex">
       <div class="flex item-center ml10"> 
            <div>统计类型：</div>
             <el-select
                size="small"
                clearable
                class="mr10"
                placeholder="选择类型"
                v-model="statisticalType"
                style="width: 100px"
                filterable
                @change = "changeStatisticalType"
           >
                <el-option label="商品数量" value="commodity"></el-option>
                <el-option label="商品名称" value="productName"></el-option>
            </el-select>
        </div>
        <!-- <el-button size="small">设置异常预警</el-button> -->
        <el-button @click="setTime(timeRange)" type="primary" size="small">刷新数据</el-button>
        <!-- <el-button size="small">导出报表</el-button> -->
     </div>
    </div>
    <div class="bg p20 mt20">
        <div class="label mb40">核心数据概览</div>
           <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8" v-for="(v, i) in overviewData" :key="i">
                   <div class="flex flex-between contentBox1 mb20" @click="goToUrl(i)">
                        <div class="flex flex-column" style="gap: 10px;">
                            <div class="titleText">{{v.title}}</div>
                            <div class="num">
                              <span class="left">{{ v.numb || 0 }}</span><span v-if="overviewData.length == i+1" class="percent">%</span>
                              <span class="right" v-if="overviewData.length != i+1">({{ (v.num_new * 100).toFixed(2) }}%)</span>
                              
                            </div>
                            <div class="collagen">
                                <div class="collagen-1" :style="{color:getCollagenColor(v.collagen)}">
                                     <i class="el-icon-top" v-if="getCollagenColor(v.collagen) == '#22C55E'"></i>
                                      <i class="el-icon-bottom" v-else></i>
                                     <span>{{Math.abs(v.collagen) || 0}}%</span>
                                </div>
                                <div class="collagen-2">{{v.text1}}</div>
                            </div>
                            <div class="beforNumb">
                                <div class="beforNumb-1">{{v.text2 || '无'}}:</div>
                                <span class="left">{{ v.beforNumb || 0 }}</span><span v-if="overviewData.length == i+1" class="percent">%</span>
                                <span class="right" v-if="overviewData.length != i+1">({{ (v.beforNumb_new * 100).toFixed(2) }}%)</span>
                            </div>
                        </div>
                        <div>
                           <img style="width: 40px;height:40px" :src="v.icon" />
                        </div>
                   </div>
                   
                </el-col>
            </el-row>
    </div>
    <div class="bg p20 mt20">
        <el-row>
            <el-col :span="24">
                <div class="label mb40">标签使用趋势</div>
                <div>
                     <ve-line :data="chartData" :settings="chartSettings" :dataEmpty='!chartData.rows.length'></ve-line>
                </div>
            </el-col>
        </el-row>
    </div>
      <div class="bg p20 mt20">
        <el-row :gutter="30">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <div class="label mb40">标签效果追踪</div>
                <div class="tabeleBox">
                     <div class="tableTitle">
                      <div>标签绩效排行榜</div>
                      <el-button
                        type="success"
                        size="small"
                        @click="output1"
                        :loading="isOutputing1"
                        >导出标签绩效排行榜</el-button
                      >
                     </div>
                     <div class="table">
                        <el-table
                            stripe
                            :data="rankingListNew"
                            style="width: 100%"
                            id="table"
                            size="small"
                        >
                            <el-table-column
                            type="index"
                            label="序号"
                            header-align="center"
                            align="center"
                            :index="index => index + (ranking.currentPage - 1) * ranking.pageSize + 1"
                            ></el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            prop="标签名称"
                            show-overflow-tooltip
                            label="标签名称"
                            >
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            prop="匹配趋势"
                            label="匹配趋势"
                            >
                             <template slot-scope="scope">
                                <div class="matchingRatioBox" :style="getStyle(scope.row.匹配趋势)" >{{scope.row.匹配趋势}}%</div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            prop="当前总应用数"
                            show-overflow-tooltip
                            label="当前总应用数"
                            >
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            prop="当前总通过数"
                            show-overflow-tooltip
                            label="当前总通过数"
                            >
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            prop="当前覆盖率"
                            show-overflow-tooltip
                            label="当前覆盖率"
                            >
                            <template slot-scope="scope">
                                <div class="matchingRatioBox">{{scope.row.当前覆盖率}}%</div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            prop="当前匹配率"
                            show-overflow-tooltip
                            label="当前匹配率"
                            >
                            <template slot-scope="scope">
                                <div class="matchingRatioBox">{{scope.row.当前匹配率}}%</div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            prop="上期总应用数"
                            show-overflow-tooltip
                            label="上期总应用数"
                            >
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            prop="上期总通过数"
                            show-overflow-tooltip
                            label="上期总通过数"
                            >
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            prop="上期覆盖率"
                            show-overflow-tooltip
                            label="上期覆盖率"
                            >
                            <template slot-scope="scope">
                                <div class="matchingRatioBox">{{scope.row.上期覆盖率}}%</div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            prop="上期匹配率"
                            show-overflow-tooltip
                            label="上期匹配率"
                            >
                            <template slot-scope="scope">
                                <div class="matchingRatioBox">{{scope.row.上期匹配率}}%</div>
                            </template>
                            </el-table-column>
                            
                            
                        </el-table>
                        </div>
                        <div class="hm-pagination">
                           <el-pagination
                                background
                                :total="ranking.total"
                                @current-change="rankingPaging"
                                :page-size="ranking.pageSize"
                                @size-change="rankingHandleSizeChange"
                                layout="total,sizes,  prev, pager, next, jumper"
                                :current-page="ranking.currentPage"
                            ></el-pagination>
                        </div>
                </div>
            </el-col>
            <el-col class="mt20" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <div class="label mb40">门店维度分析</div>
                <div class="tabeleBox">
                     <div class="tableTitle">
                      <div>门店排名</div>
                      <el-button
                        type="success"
                        size="small"
                        @click="output2"
                        :loading="isOutputing2"
                        >导出门店排名</el-button
                      >
                     </div>
                     <div class="table">
                        <el-table
                            stripe
                            :data="shopListNew"
                            style="width: 100%"
                            id="table"
                            size="small"
                        >
                            <el-table-column
                            type="index"
                            label="序号"
                            header-align="center"
                            align="center"
                            :index="index => index + (shop.currentPage - 1) * shop.pageSize + 1"
                            ></el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            show-overflow-tooltip
                            prop="门店名称"
                            label="门店名称"
                            >
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            prop="通过率趋势"
                            label="通过率趋势"
                            >
                             <template slot-scope="scope">
                                <div class="matchingRatioBox" :style="getStyle(scope.row.通过率趋势)">
                                  {{ scope.row.通过率趋势 }}%
                                </div>
                            </template>
                            </el-table-column>

                            <el-table-column
                            header-align="center"
                            align="center"
                            show-overflow-tooltip
                            prop="当前门店总单量"
                            label="当前门店总单量"
                            >
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            show-overflow-tooltip
                            prop="当前门店总自动通过"
                            label="当前门店总自动通过"
                            >
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            show-overflow-tooltip
                            prop="当前自动通过率"
                            label="当前自动通过率"
                            >
                            <template slot-scope="scope">
                                <div class="matchingRatioBox">{{scope.row.当前自动通过率}}%</div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            show-overflow-tooltip
                            prop="当前总应用数"
                            label="当前总应用数"
                            >
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            show-overflow-tooltip
                            prop="当前总通过数"
                            label="当前总通过数"
                            >
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            prop="当前用标签匹配通过率"
                            label="当前用标签匹配通过率"
                            >
                             <template slot-scope="scope">
                                <div class="matchingRatioBox">{{scope.row.当前用标签匹配通过率}}%</div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            show-overflow-tooltip
                            prop="上期门店总单量"
                            label="上期门店总单量"
                            >
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            show-overflow-tooltip
                            prop="上期门店总自动通过"
                            label="上期门店总自动通过"
                            >
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            show-overflow-tooltip
                            prop="上期自动通过率"
                            label="上期自动通过率"
                            >
                            <template slot-scope="scope">
                                <div class="matchingRatioBox">{{scope.row.上期自动通过率}}%</div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            show-overflow-tooltip
                            prop="上期总应用数"
                            label="上期总应用数"
                            >
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            show-overflow-tooltip
                            prop="上期总通过数"
                            label="上期总通过数"
                            >
                            </el-table-column>
                            <el-table-column
                            header-align="center"
                            align="center"
                            prop="上期用标签匹配通过率"
                            label="上期用标签匹配通过率"
                            >
                             <template slot-scope="scope">
                                <div class="matchingRatioBox">{{scope.row.上期用标签匹配通过率}}%</div>
                            </template>
                            </el-table-column>
                            
                            
                            
                        </el-table>
                        </div>
                        <div class="hm-pagination">
                           <el-pagination
                                background
                                :total="shop.total"
                                @current-change="shopPaging"
                                :page-size="shop.pageSize"
                                @size-change="shopHandleSizeChange"
                                layout="total,sizes,  prev, pager, next, jumper"
                                :current-page="shop.currentPage"
                            ></el-pagination>
                        </div>
                </div>
            </el-col>
        </el-row>
    </div>
  </div>
</template>

<script>

import VeLine from "v-charts/lib/histogram.common";
import 'v-charts/lib/style.css'

export default {
  components: {
    VeLine,
  },
  name: "home",
  data() {
    this.chartSettings = {
        showLine: ['系统自动通过率', '数量不一致未自动通过占比', '用标后自动通过占整体自动通过比例'],
        yAxisType: ['0,0', '0.[00]%'],
        area: false,
        axisSite: {
          right: ['系统自动通过率', '数量不一致未自动通过占比', '用标后自动通过占整体自动通过比例']
        },
        yAxisName: ['数量', '百分比']
      };
    return {
       timeRange: 2,
       // 日期范围
        dateRange: [],
        // 选择的时间段的前一段的时间
        lastDateRange: [],
        timeHorizon: 'yesterday',
        statisticalType: 'commodity',
        overviewData:[],
        chartData: {
        columns: ['日期', '申报总单量', '系统自动通过率','数量不一致未自动通过的单量','数量不一致未自动通过占比','使用标签后自动通过总单量', '用标后自动通过占整体自动通过比例'],
        rows: []
      },
      rankingList:[],
      rankingListNew:[],
      ranking:{
        total:10,
        currentPage: 1,
        pageSize: 10,
      },
      shopList:[],
      shopListNew:[],
       shop:{
        total:10,
        currentPage: 1,
        pageSize: 10,
      },
      applyDate:[],
      isOutputing1:false,
      isOutputing2:false
    };
  },
  created() {
   this.setTime(2)
  },

  methods: {
     getTime(datePar) {
        const d = datePar ? new Date(datePar) : new Date()
        d.setMinutes(d.getMinutes() - d.getTimezoneOffset())
        return d.toJSON().substring(0, 10)
      },

      getStyle(value) {
      let color, bgColor;
      if (value > 0) {
        color = '#166534';
        bgColor = '#DCFCE7';
      } else if (value < 0) {
        color = '#991b1b';
        bgColor = '#fee2e2';
      } else {
        color = '#a16207';
        bgColor = '#fef9c3';
      }
      return { color, backgroundColor: bgColor };
    },

    setTime(days) {
        this.timeRange = days
        if (days) {
          let date = new Date()
          let date2 = new Date()
          date.setDate(date.getDate() - days)
          if(days === 3) {
             date2.setDate(date2.getDate() - 2)
          }else {
             date2.setDate(date2.getDate() - 1)
          }
          this.dateRange = [`${this.getTime(date)}`, this.getTime(date2)]
          if(days === 7) {
            let lastDate = new Date(this.dateRange[0])
            let lastDate2 = new Date(this.dateRange[0])
            lastDate.setDate(lastDate.getDate(this.dateRange[0]) - days)
            lastDate2.setDate(lastDate2.getDate(this.dateRange[0]) - 1)
            this.lastDateRange = [this.getTime(lastDate), this.getTime(lastDate2)]
          }else {
            this.lastDateRange = null
          }
          if (this.timeRange < 7) {
            this.getList(
              `${this.dateRange[1]} 00:00:00`,
              `${this.dateRange[1]} 23:59:59`,
              `${this.dateRange[0]} 00:00:00`,
              `${this.dateRange[0]} 23:59:59`,
            )
          }else if(this.timeRange == 7) {
            this.getList(
              `${this.dateRange[0]} 00:00:00`,
              `${this.dateRange[1]} 23:59:59`,
              `${this.lastDateRange[0]} 00:00:00`,
              `${this.lastDateRange[1]} 23:59:59`,
            )
          }
          
        } else {
          this.dateRange = null
          this.lastDateRange = null
        }
      },
            // 计算总申报单量的百分比变化
      calculatePercentageDifferenceTotalDeclaration(currentData, lastData) {
        const currentValue = currentData.申报总单量 || 0;
        const lastValue = lastData.申报总单量 || 1; // 防止除以 0
        
        const difference = ((currentValue - lastValue) / lastValue) * 100;
        return parseFloat(difference.toFixed(2));
      },

      // 计算数量问题未自动通过的单量的百分比变化
      calculatePercentageDifferenceQuantityIssue(currentData, lastData) {
        const currentValue = currentData.数量不一致未自动通过的单量 || 0;
        const lastValue = lastData.数量不一致未自动通过的单量 || 1; // 防止除以 0
        
        const difference = ((currentValue - lastValue) / lastValue) * 100;
        return parseFloat(difference.toFixed(2));
      },
      // 计算数量一件自动通过的单量的百分比变化
      calculatePercentageDifferenceQuantityIssue3(currentData, lastData) {
        const currentValue = currentData.数量大于一件 || 0;
        const lastValue = lastData.数量大于一件 || 1; // 防止除以 0
        
        const difference = ((currentValue - lastValue) / lastValue) * 100;
        return parseFloat(difference.toFixed(2));
      },
      calculatePercentageDifference1(currentData, lastData) { //应用标签总量
          // 默认值处理，防止 undefined 或 null 引发错误
          const currentUse = currentData.使用标签总申报量 || 0;
          const currentTotal = currentData.总单量 || 1; // 防止除以 0，默认为 1
          const lastUse = lastData.使用标签总申报量 || 0;
          const lastTotal = lastData.总单量 || 1; // 防止除以 0，默认为 1

          const currentRatio = currentUse / currentTotal;
          const lastRatio = lastUse / lastTotal;

          const difference = ((currentRatio - lastRatio) / lastRatio) * 100;
          return parseFloat(difference.toFixed(2)); // 返回保留两位小数的数值
        },
        calculatePercentageDifference2(currentData, lastData) {
          const currentValue = currentData.使用标签总门店数 || 0;
          const lastValue = lastData.使用标签总门店数 || 1; // 防止除以 0
          
          const difference = ((currentValue - lastValue) / lastValue) * 100;
          return parseFloat(difference.toFixed(2));
        },
         calculatePercentageDifference3(currentData, lastData) {
          const currentValue = currentData.总系统自动通过单数 || 0;
          const lastValue = lastData.总系统自动通过单数 || 1; // 防止除以 0
          
          const difference = ((currentValue - lastValue) / lastValue) * 100;
          return parseFloat(difference.toFixed(2));
        },
         calculatePercentageDifference4(currentRatio, lastRatio) { //百分率

          const difference = (currentRatio - lastRatio);
          return parseFloat(difference.toFixed(2)); // 返回保留两位小数的数值
        },
     async getList(time1, time2, time3, time4) {
        //  if( this.timeRange < 7) {
          this.applyDate = [time1, time2];
            let params1 = {
              ew: {
              startDateTime: time1,
              endDateTime: time2
            },
            templateCode: "redpackage_tag_overview"
          }
            let params = {
              ew: {
              startDateTime: time3,
              endDateTime: time4
            },
            templateCode: "redpackage_tag_overview"
          }
          let params3 = {
              ew: {
              startDateTime: time1,
              endDateTime: time2
            },
            templateCode: "redpackage_tag_regular_num_stat"
          }
            let params4 = {
              ew: {
              startDateTime: time3,
              endDateTime: time4
            },
            templateCode: "redpackage_tag_regular_num_stat"
          }
          
          // box1的数据
           const [dataValue, lastDataValue] = await Promise.all([
              this.templateObtainData1(params1),
              this.templateObtainData1(params)
            ]);
            const [dataValue1, lastDataValue1] = await Promise.all([
              this.templateObtainData1(params3),
              this.templateObtainData1(params4)
            ]);
            let text1 = ''
            let text2 = ''
            let collagenQuantityIssue1 = this.calculatePercentageDifferenceTotalDeclaration(dataValue[0], lastDataValue[0])
            let collagenQuantityIssue2 = this.calculatePercentageDifferenceQuantityIssue(dataValue[0], lastDataValue[0])
            let collagenQuantityIssue3 = this.calculatePercentageDifferenceQuantityIssue3(dataValue[0], lastDataValue[0])
            let collagen1 = this.calculatePercentageDifference1(dataValue[0], lastDataValue[0])
            let collagen2 = this.calculatePercentageDifference2(dataValue[0], lastDataValue[0])
            let collagen3 = this.calculatePercentageDifference3(dataValue[0], lastDataValue[0])
            let collagen4 = this.calculatePercentageDifference4(dataValue[0].系统自动通过率 || 0, lastDataValue[0].系统自动通过率 || 0)
            if(this.timeRange === 2) {
              text1 = '较2日前'
              text2 = '前日'
            }else if(this.timeRange === 3) {
              text1 = '较3日前'
              text2 = '前一日'
            }else if(this.timeRange === 7) {
              text1 = '较近一周'
              text2 = '上期'
            }
           this.overviewData = [
            {
              title: '总申报单量/自动通过率',
              numb: dataValue[0].申报总单量,
              num_new: dataValue[0].系统自动通过率a,
              collagen: collagenQuantityIssue1,
              text1: text1,
              text2: text2,
              beforNumb: lastDataValue[0].申报总单量,
              beforNumb_new:lastDataValue[0].系统自动通过率a,
              icon: require("@/assets/receiptTemplate_icon1.png")
            },
            {
              title: '数量大于一件/数量大于一件自动通过占比',
              numb: dataValue[0].数量大于一件,
              num_new: dataValue[0].数量大于一件自动通过占比,
              collagen: collagenQuantityIssue3,
              text1: text1,
              text2: text2,
              beforNumb: lastDataValue[0].数量大于一件,
              beforNumb_new:lastDataValue[0].数量大于一件自动通过占比,
              icon: require("@/assets/receiptTemplate_icon1.png")
            },
            {
              title: '数量问题未自动通过的单量/占比全部未通过单',
              numb: dataValue[0].数量不一致未自动通过的单量,
              num_new: dataValue[0].数量不一致未自动通过占比,
              collagen: collagenQuantityIssue2,
              text1: text1,
              text2: text2,
              beforNumb: lastDataValue[0].数量不一致未自动通过的单量,
              beforNumb_new: lastDataValue[0].数量不一致未自动通过占比,
              icon: require("@/assets/receiptTemplate_icon1.png")
            },
            {
              title: '打标门店总单量/占比全部单量',
              numb: dataValue[0].使用标签总申报量,
              num_new: dataValue[0].有数量标签的门店单量占整体比例,
              collagen: collagen1,
              text1: text1,
              text2: text2,
              beforNumb: lastDataValue[0].使用标签总申报量,
              beforNumb_new: lastDataValue[0].有数量标签的门店单量占整体比例,
              icon: require("@/assets/receiptTemplate_icon1.png")
            },
            {
              title: '覆盖门店数量/占比日活门店',
              numb: dataValue[0].使用标签总门店数,
              num_new: dataValue[0].配置门店占比,
              collagen: collagen2,
              text1: text1,
              text2: text2,
              beforNumb: lastDataValue[0].使用标签总门店数,
              beforNumb_new: lastDataValue[0].配置门店占比,
              icon: require("@/assets/receiptTemplate_icon2.png")
            },
            {
              title: '数量匹配正确的单量/门店单量占比',
              numb: dataValue[0].总系统自动通过单数,
              num_new: dataValue[0].标签匹配率,
              collagen: collagen3,
              text1: text1,
              text2: text2,
              beforNumb: lastDataValue[0].总系统自动通过单数,
              beforNumb_new: lastDataValue[0].标签匹配率,
              icon: require("@/assets/receiptTemplate_icon3.png")
            },
            {
              title: '用标签自动通过比例',
              numb: dataValue[0].系统自动通过率,
              collagen: collagen4,
              text1: text1,
              text2: text2,
              beforNumb: lastDataValue[0].系统自动通过率,
              icon: require("@/assets/receiptTemplate_icon4.png")
            }
          ],
          console.log(dataValue,lastDataValue)
          // 图表的数据
          this.chartData.rows = []
          let params5 = {
              ew: {
              startDateTime: time1,
              endDateTime: time2
            },
            templateCode: "redpackage_tag_regular_daily_stat"
          }
            const [dataValue2] = await Promise.all([
              this.templateObtainData1(params5)
            ]);
            if (dataValue2.length > 0) {
              const newData = dataValue2.map(v => ({
                日期: v.统计日期 || '',
                申报总单量: v.申报总单量 || 0,
                系统自动通过率: v.系统自动通过率 || 0,
                数量不一致未自动通过的单量: v.数量不一致未自动通过的单量 || 0,
                数量不一致未自动通过占比: v.数量不一致未自动通过占比 || 0,
                使用标签后自动通过总单量: v.使用标签后自动通过总单量 || 0,
                用标后自动通过占整体自动通过比例: v.用标后自动通过占整体自动通过比例 || 0
                // 匹配率: typeof v.正则匹配率 === 'number' && !isNaN(v.正则匹配率) ? v.正则匹配率 / 100 : 0,
                // 异常识别数: v.使用标签人工通过 || 0
              }));

              this.chartData.rows.push(...newData);
            }else { 
              this.chartData.rows = []
            }
          // 表格数据
          let params6 = {
              ew: {
              startDateTime: time1,
              endDateTime: time2
            },
            templateCode: "redpackage_tag_rank"
          }
          let params7 = {
              ew: {
              startDateTime: time1,
              endDateTime: time2
            },
            templateCode: "redpackage_tag_shop_rank"
          }
           const [dataValue3, dataValue4] = await Promise.all([
              this.templateObtainData1(params6),
              this.templateObtainData1(params7)
            ]);
            if(dataValue3.length) {
              this.rankingList = dataValue3
              this.getRankingList()
            }else {
              this.rankingList = []
              this.rankingListNew = []

            }
            if(dataValue4.length) {
              this.shopList = dataValue4
              this.getShopList()
            }else {
              this.shopList = []
              this.shopListNew = []
            }
            
        //  }
        console.log(this.dateRange,this.lastDateRange)
      },
    async getRankingList() {
    // 标签当前分页的数据
      const totalPages = Math.ceil(this.rankingList.length / this.ranking.pageSize);
      if (this.ranking.currentPage > totalPages) {
            this.ranking.currentPage = totalPages || 1; // 确保至少为第一页
          }
      this.ranking.total = this.rankingList.length;
      console.log("getRankingList", this.rankingList.length,this.ranking.total);
      // 获取当前页的第一项
      const startIndex =
        (this.ranking.currentPage - 1) * this.ranking.pageSize;
      const endIndex = this.ranking.currentPage * this.ranking.pageSize;
      this.rankingListNew = this.rankingList.slice(startIndex, endIndex);
      console.log("startIndex", startIndex);
      console.log("endIndex", endIndex);
      console.log("根据假分页处理的数据", this.rankingListNew);
      this.$nextTick(() => {
         this.rankingListNew = this.rankingList.slice(startIndex, endIndex);
	    });
      this.$forceUpdate()
    },
    async getShopList() {
    // 门店当前分页的数据
      const totalPages = Math.ceil(this.shopList.length / this.shop.pageSize);
      if (this.shop.currentPage > totalPages) {
            this.shop.currentPage = totalPages || 1; // 确保至少为第一页
          }
      this.shop.total = this.shopList.length;
      console.log("getShopList", this.shopList.length,this.shop.total);
      // 获取当前页的第一项
      const startIndex =
        (this.shop.currentPage - 1) * this.shop.pageSize;
      const endIndex = this.shop.currentPage * this.shop.pageSize;
      this.shopListNew = this.shopList.slice(startIndex, endIndex);
      console.log("startIndex", startIndex);
      console.log("endIndex", endIndex);
      console.log("根据假分页处理的数据", this.shopListNew);
      this.$nextTick(() => {
         this.shopListNew = this.shopList.slice(startIndex, endIndex);
	    });
      this.$forceUpdate()
    },
     async templateObtainData1(params) {
      const { result } = await this.$store.dispatch(
        "templateObtainData",
        params
      );
     return result;
    },
    changeStatisticalType(e) {
        console.log(e)
    },
    getCollagenColor(collagen) {
      const HIGH_COLOR = '#22C55E';
      const LOW_COLOR = '#EF4444';
      return collagen > 0 ? HIGH_COLOR : LOW_COLOR;
    },
     rankingPaging(page) {
      this.ranking.currentPage = page;
      this.getRankingList();
    },
    rankingHandleSizeChange(size) {
      this.ranking.currentPage = 1;
      this.ranking.pageSize = size;
      this.getRankingList();
    },
    shopPaging(page) {
      this.shop.currentPage = page;
      this.getShopList();
    },
    shopHandleSizeChange(size) {
      this.shop.currentPage = 1;
      this.shop.pageSize = size;
      this.getShopList();
    },
    goToUrl(index) {
      if(index == 3 ||  index == 5 ||  index == 6) {
        this.$router.push({
        // name: ReceiptTemplateList,
        path: "/guiderCommission/receiptTemplate/receiptTemplateList",
        query: {
          applyDate:this.applyDate,
          type: index
        },
      });
      }else if(index == 4) {
        this.$router.push({
          path: "/guiderCommission/receiptTemplate/receiptTempalteShopList",
          query: {
            applyDate:this.applyDate,
          },
        });
      }
      
    },
     // 导出excel == 标签绩效排行榜
    output1() {
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        this.isOutputing1 = true;
         const list =  JSON.parse(JSON.stringify(this.rankingList));
        list.map(v => {
          // 为“匹配趋势”添加%
          if (v.匹配趋势 !== undefined && !v.匹配趋势.toString().includes('%')) {
            v.匹配趋势 = v.匹配趋势 + '%';
          }

          // 为“当前覆盖率”添加%
          if (v.当前覆盖率 !== undefined && !v.当前覆盖率.toString().includes('%')) {
            v.当前覆盖率 = v.当前覆盖率 + '%';
          }

          // 为“当前匹配率”添加%
          if (v.当前匹配率 !== undefined && !v.当前匹配率.toString().includes('%')) {
            v.当前匹配率 = v.当前匹配率 + '%';
          }

          // 为“上期覆盖率”添加%
          if (v.上期覆盖率 !== undefined && !v.上期覆盖率.toString().includes('%')) {
            v.上期覆盖率 = v.上期覆盖率 + '%';
          }

          // 为“上期匹配率”添加%
          if (v.上期匹配率 !== undefined && !v.上期匹配率.toString().includes('%')) {
            v.上期匹配率 = v.上期匹配率 + '%';
          }

          return v;
        });
            const tHeader = [
              "标签名称",
              "匹配趋势",
              "当前总应用数",
              "当前总通过数",
              "当前覆盖率",
              "当前匹配率",
              "上期总应用数",
              "上期总通过数",
              "上期覆盖率",
              "上期匹配率"
            ];
            const filterVal = [
              "标签名称",
              "匹配趋势",
              "当前总应用数",
              "当前总通过数",
              "当前覆盖率",
              "当前匹配率",
              "上期总应用数",
              "上期总通过数",
               "上期覆盖率",
               "上期匹配率"
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(tHeader, data, "标签绩效排行榜");
            this.isOutputing1 = false;
      });
    },
      // 导出excel == 门店排名
    output2() {
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        this.isOutputing2 = true;
         const list = JSON.parse(JSON.stringify(this.shopList));
        list.map(v => {
          // 为“通过率趋势”添加%
          if (v.通过率趋势 !== undefined && !v.通过率趋势.toString().includes('%')) {
            v.通过率趋势 = v.通过率趋势 + '%';
          }

          // 为“当前自动通过率”添加%
          if (v.当前自动通过率 !== undefined && !v.当前自动通过率.toString().includes('%')) {
            v.当前自动通过率 = v.当前自动通过率 + '%';
          }

          // 为“当前用标签匹配通过率”添加%
          if (v.当前用标签匹配通过率 !== undefined && !v.当前用标签匹配通过率.toString().includes('%')) {
            v.当前用标签匹配通过率 = v.当前用标签匹配通过率 + '%';
          }

          // 为“上期自动通过率”添加%
          if (v.上期自动通过率 !== undefined && !v.上期自动通过率.toString().includes('%')) {
            v.上期自动通过率 = v.上期自动通过率 + '%';
          }

          // 为“上期用标签匹配通过率”添加%
          if (v.上期用标签匹配通过率 !== undefined && !v.上期用标签匹配通过率.toString().includes('%')) {
            v.上期用标签匹配通过率 = v.上期用标签匹配通过率 + '%';
          }

          return v;
        });
            const tHeader = [
              "门店名称",
              "通过率趋势",
              "当前门店总单量",
              "当前门店总自动通过",
              "当前自动通过率",
              "当前总应用数",
              "当前总通过数",
              "当前用标签匹配通过率",
              "上期门店总单量",
              "上期门店总自动通过",
              "上期自动通过率",
              "上期总应用数",
              "上期总通过数",
              "上期用标签匹配通过率",
            ];
            const filterVal = [
              "门店名称",
              "通过率趋势",
              "当前门店总单量",
              "当前门店总自动通过",
              "当前自动通过率",
              "当前总应用数",
              "当前总通过数",
              "当前用标签匹配通过率",
               "上期门店总单量",
               "上期门店总自动通过",
               "上期自动通过率",
                "上期总应用数",
              "上期总通过数",
              "上期用标签匹配通过率",
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(tHeader, data, "门店排名");
            this.isOutputing2 = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
  },
};
</script>
<style lang="scss" scoped>
.bg {
  background: #fff;
  box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.05);
  border-radius: 16px 16px 16px 16px;
}
.label {
    font-size: 24px;
}
.contentBox1 {
    padding: 24px;
    box-sizing: border-box;
    // background: pink;
    background:#F9FAFB;
    box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.05);
    border-radius: 16px 16px 16px 16px;
    cursor: pointer;
    .titleText {
        font-weight: 500;
        font-size: 16px;
        color: #6B7280;
    }
    .num {
        font-weight: 700;
        font-size: 30px;
        color: #1F2937;
    }
    .collagen {
        display: flex;
        font-weight: 500;
        font-size: 14px;
        color: #22C55E;
        .collagen-2 {
            margin-left: 10px;
            color: #6B7280;
        }
    }
    .beforNumb {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 12px;
        color: #9CA3AF;
    }
}
.tabeleBox {
    padding: 20px;
    box-sizing: border-box;
    background: #F9FAFB;
    border-radius: 16px 16px 16px 16px;
    border: 1px solid #E5E7EB;
    .tableTitle {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 500;
        font-size: 21px;
        color: #374151;
        margin-bottom: 20px;
    }
}
.matchingRatioBox {
    margin: 0 auto;
    font-weight: 500;
    font-size: 16px;
    color: #166534;
    height: 30px;
    line-height: 30px;
    padding: 0 15px;
    background: #DCFCE7;
    border-radius: 30px;
    width:fit-content;
    width:-webkit-fit-content;
    width:-moz-fit-content;
 }
.coverageBox {
    color: #1E40AF;
    background: #DBEAFE;
}
</style>
